import { render, staticRenderFns } from "./UserCopper.vue?vue&type=template&id=140778e9&scoped=true&"
import script from "./UserCopper.vue?vue&type=script&lang=js&"
export * from "./UserCopper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140778e9",
  null
  
)

export default component.exports